import * as React from 'react'

import { ImageIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { FilePicker } from '~/client/src/shared/components/FilePicker'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { cn } from '~/client/src/shared/utils/cn'

import { FileUploadingStore } from '../../stores/domain/FileUploading.store'
import InitialState from '../../stores/InitialState'
import { ISharedProps } from '../StruxhubInputs/BaseStruxhubInput'
import StruxhubInputHelperText from '../StruxhubInputs/components/StruxhubInputHelperText'
import ImageInputStore from './ImageInput.store'

const ACCEPT_PATTERN = 'image/*'

interface IProps extends ISharedProps {
  onChange: (newUrl: string) => void
  fileUploadingStore?: FileUploadingStore
  state?: InitialState
  maxFileSize?: number
  maxWidth?: number
  maxHeight?: number
  shoulOmitCreateLog?: boolean
}

@inject('fileUploadingStore', 'state')
@observer
export default class ImageInput extends React.Component<IProps> {
  private readonly store: ImageInputStore = null

  public constructor(props: IProps) {
    super(props)
    this.store = new ImageInputStore(props.onChange, props.fileUploadingStore)
  }

  public render() {
    const { label, className } = this.props
    const { isLoading, errorMessage } = this.store

    return (
      <>
        <FilePicker
          accept={ACCEPT_PATTERN}
          disabled={isLoading}
          onPick={this.uploadImage}
          render={
            <Button
              variant="outline"
              className={cn('tw:mb-1.25 tw:w-full', className)}
            />
          }
        >
          {isLoading ? (
            <span data-icon="inline-start">
              <Spinner size="xs" />
            </span>
          ) : (
            <ImageIcon data-icon="inline-start" />
          )}
          {isLoading ? Localization.translator.uploading : label}
        </FilePicker>
        {errorMessage && (
          <StruxhubInputHelperText
            isChanged={false}
            isValid={false}
            validationMessage={errorMessage}
          />
        )}
      </>
    )
  }

  private uploadImage = async ([fileToUpload]: File[]) => {
    const {
      maxFileSize,
      maxWidth,
      maxHeight,
      state: {
        activeProject: { id: projectId },
      },
      shoulOmitCreateLog,
    } = this.props
    return this.store.change(
      fileToUpload,
      projectId,
      maxFileSize,
      maxWidth,
      maxHeight,
      shoulOmitCreateLog,
    )
  }
}
